import React from 'react';

import InputError from './InputError';

import './Select.css';

export interface PotentialAnswers {
  description: string;
  id: string;
  order: number;
  text: string;
}

interface Props {
  potentialAnswers: PotentialAnswers[];
  name: string;
  isFormGroup?: boolean;
  isSmall?: boolean;
  isNextSmall?: boolean;
  placeholder?: string | null;
  formik: any;
  inputChangeCallback?: () => void;
  additionalClasses?: string;
}

const Select: React.FC<Props> = props => {
  const { isFormGroup, isSmall, placeholder, name, formik, isNextSmall, potentialAnswers, inputChangeCallback } = props;
  // const { configuration } = useContext(CommonContext);

  return (
    <label
      className={`ui-widget-label ui-widget-label${isSmall ? '-small' : '-big'} ui-widget-label${
        isNextSmall ? '-next-small' : '-next-big'
      } ${formik.touched[name] && formik.errors[name] ? 'ui-widget-label-error' : ''} ${
        isFormGroup ? 'ui-widget-label-group' : 'ui-widget-label-not-group'
      } ${props.additionalClasses}`}
    >
      {/*<p className="ui-widget-label-text" style={{ color: (configuration?.PrimaryColor as string) || PRIMARY_COLOR }}>*/}
      {/*  {placeholder}*/}
      {/*</p>*/}
      <select
        className="ui-widget-dropdown"
        placeholder={placeholder || ''}
        {...formik.getFieldProps(name)}
        onChange={e => {
          formik.handleChange(e);
          inputChangeCallback?.();
        }}
      >
        {potentialAnswers.map(answer => (
          <option key={answer.id} value={answer.id}>
            {answer.text}
          </option>
        ))}
      </select>
      <InputError formik={formik} name={name} isFormGroup={isFormGroup} />
    </label>
  );
};

export default Select;
